import {createRoot, hydrateRoot} from 'react-dom/client';
import WorkGallery from '../pages/WorkGallery/WorkGallery'
import "../index.css";
import "../pages/WorkGallery/WorkGallery.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<WorkGallery {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <WorkGallery {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).WorkGalleryVC = {mount, hydrate, unmount}